<template>
  <b-col class="pb-3" :xl="horizontal ? 6 : 4" :lg="horizontal ? 6 : 4" :sm="horizontal ? 12 : 6" cols="12">
    <div class="tool shadow rounded-lg" :class="{ 'tool--horizontal': horizontal }">
      <img class="tool__icon" :src="iconSrc"/>
      <div class="tool__info">
        <h4 class="tool__title mb-1" v-html="$t(`routes.${route.name}`)"></h4><span class="tool__tag">{{tag}}</span>
        <p class="tool__text" v-html="$t(`products.tools.${route.name}`)"/>
        <b-link v-if="showCta" :to="{ name: route.name }">{{$t(`learn-more`)}}</b-link>
      </div>
    </div>
  </b-col>
</template>

<script>
export default {
  name: 'Tool',
  props: {
    route: Object,
    tag: String,
    horizontal: { type: Boolean, default: false }
  },
  computed: {
    iconSrc ({ route }) { return require(`@/assets/${route.path}/${route.path}-icon.png`) },
    showCta ({ route }) { return route.groups && !route.groups.commingSoon }
  }
}
</script>

<style lang="sass" scoped>
.tool
  display: flex
  flex-direction: column
  align-items: center
  padding: $spacer
  position: relative
  height: 100%
  background: $white
  &--horizontal
    +media-breakpoint-up(sm)
      flex-direction: row
      padding: $spacer * 1.25

  &--horizontal &__icon
    +media-breakpoint-up(sm)
      margin-right: $spacer
      width: 100px
      margin-bottom: 0

  &__icon
    margin-bottom: $spacer * .75
    margin-top: 20px
    width: 50px

  &--horizontal &__info
    +media-breakpoint-up(sm)
      align-items: start
      text-align: left

  &__info
    display: flex
    flex-direction: column
    flex: 1 1
    align-items: center
    text-align: center

  &__title
    font-size: 1rem

  &__tag
    position: absolute
    top: $spacer * .75
    right: $spacer * .75
    font-size: 12px
    font-weight: bold
    letter-spacing: .8px
    text-transform: uppercase
    color: $purple
    +media-breakpoint-down(sm)
      font-size: 10px

  &__text
    font-size: 14px
    flex: 1 1
</style>



// WEBPACK FOOTER //
// src/components/ui/products/Tool.vue